import { render, staticRenderFns } from "./heart.vue?vue&type=template&id=2a48e4d1&scoped=true"
import script from "./heart.vue?vue&type=script&lang=js"
export * from "./heart.vue?vue&type=script&lang=js"
import style0 from "./heart.vue?vue&type=style&index=0&id=2a48e4d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a48e4d1",
  null
  
)

export default component.exports